const NETWORK_CODES = new Set(['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT', 'OFFLINE', 'ERR_CONNECTION_REFUSED']);

export const MOP_AUTHORIZATION_FAILURE_TYPES = {
  SERVER_ERROR: 'server_error',
  AUTH_SERVER_UNAVAILABLE: 'auth_server_unavailable',
  NETWORK_ERROR: 'network_error',
  REQUEST_ABORTED: 'request_aborted',
  AUTH_ERROR: 'auth_error',
  UNKNOWN_ERROR: 'unknown_error',
};

export function classifyMopAuthorizationFailure(error) {
  const hasResponse = !!error?.response;
  const httpStatus = error?.response?.status;
  const errorCode = error?.code;
  const errorName = error?.name;
  const isRefreshError = !!error?.isRefreshError;
  const rawMessage = error?.message || '';
  const responseData = error?.response?.data;
  const responseText = [
    responseData?.Message,
    responseData?.error,
    responseData?.error_description,
  ]
    .filter(Boolean)
    .join(' ');
  const failureText = `${rawMessage} ${responseText}`.trim();
  const isOAuthRefreshFailure =
    httpStatus === 400 && /invalid_grant|invalid_request/i.test(failureText);

  if (errorCode === 'CIRCUIT_OPEN') {
    return MOP_AUTHORIZATION_FAILURE_TYPES.AUTH_SERVER_UNAVAILABLE;
  }

  if (
    httpStatus === 401 ||
    /refresh token not found|invalid authentication token/i.test(failureText) ||
    (isRefreshError && isOAuthRefreshFailure)
  ) {
    return MOP_AUTHORIZATION_FAILURE_TYPES.AUTH_ERROR;
  }

  if (
    NETWORK_CODES.has(errorCode) ||
    /network error|request timeout|timeout exceeded|failed to fetch/i.test(failureText)
  ) {
    return MOP_AUTHORIZATION_FAILURE_TYPES.NETWORK_ERROR;
  }

  if (errorCode === 'ERR_CANCELED' || errorName === 'AbortError') {
    return MOP_AUTHORIZATION_FAILURE_TYPES.REQUEST_ABORTED;
  }

  if (isRefreshError && !hasResponse) {
    return MOP_AUTHORIZATION_FAILURE_TYPES.AUTH_SERVER_UNAVAILABLE;
  }

  if (hasResponse && httpStatus >= 500) {
    return MOP_AUTHORIZATION_FAILURE_TYPES.NETWORK_ERROR;
  }

  if (hasResponse) {
    return MOP_AUTHORIZATION_FAILURE_TYPES.SERVER_ERROR;
  }

  return MOP_AUTHORIZATION_FAILURE_TYPES.UNKNOWN_ERROR;
}

export function getMopAuthorizationUserMessage(failureType, fallbackMessage) {
  const userMessages = {
    [MOP_AUTHORIZATION_FAILURE_TYPES.SERVER_ERROR]: fallbackMessage,
    [MOP_AUTHORIZATION_FAILURE_TYPES.AUTH_SERVER_UNAVAILABLE]:
      'Our authentication service is temporarily unavailable. Please try again in a few minutes.',
    [MOP_AUTHORIZATION_FAILURE_TYPES.NETWORK_ERROR]:
      'Unable to reach the payment service. Please try again in a few minutes.',
    [MOP_AUTHORIZATION_FAILURE_TYPES.REQUEST_ABORTED]:
      'Your action was interrupted. Please refresh the page and try again.',
    [MOP_AUTHORIZATION_FAILURE_TYPES.AUTH_ERROR]:
      'Your session has expired. Please refresh the page and try again.',
    [MOP_AUTHORIZATION_FAILURE_TYPES.UNKNOWN_ERROR]:
      'An unexpected error occurred. Please refresh the page and try again. If the problem continues, contact support.',
  };

  return userMessages[failureType] || userMessages[MOP_AUTHORIZATION_FAILURE_TYPES.UNKNOWN_ERROR];
}
